import { render } from "./MNCASAStrongPartnerships.vue?vue&type=template&id=704c747b&scoped=true"
import script from "./MNCASAStrongPartnerships.vue?vue&type=script&lang=js"
export * from "./MNCASAStrongPartnerships.vue?vue&type=script&lang=js"

import "./MNCASAStrongPartnerships.vue?vue&type=style&index=0&id=704c747b&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704c747b"]])

export default __exports__